import { useCssVars, computed, toRef, ref, resolveComponent, createBlock, openBlock, withCtx, createElementVNode, mergeProps, createVNode, unref, createElementBlock, normalizeProps } from "vue";
import "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import { imgUtils } from "../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css               */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "./index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                  */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import { useTheme } from "../../composables/useTheme.js";
import "tiny-emitter/instance";
import "../../graphql/system-settings.js";
/* empty css                       */
/* empty css                                    */
import { VHover } from "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                      */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                      */
import "vuetify/components/VTooltip";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/lookups.js";
import "../../graphql/entity.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css               */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                   */
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                  */
import "vuetify/components/VFileInput";
/* empty css                            */
import { VAvatar } from "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                         */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                            */
import "vuetify/components/VItemGroup";
/* empty css                       */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                  */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
/* empty css                 */
const _hoisted_1 = ["src"];
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "BanzaAvatar",
  props: {
    contact: {
      type: Object,
      default: null
    },
    photoId: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: "primary"
    },
    borderWidth: {
      type: Number,
      default: 2
    },
    preset: {
      type: String,
      default: null
    }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "6a3490ec": colorCss.value,
      "33ad96f5": borderWidthCss.value
    }));
    const props = __props;
    const { preset, attrs, resolveColor } = useTheme({
      componentKey: "BanzaAvatar",
      presetName: toRef(() => props.preset)
    });
    const hasError = ref(false);
    const hasOnClickListener = computed(() => {
      return attrs.value.onClick || attrs.value.href;
    });
    const avatarSrc = computed(() => {
      return props.image ? props.image : props.photoId ? imgUtils.getAvatarUrl(props.photoId) : imgUtils.getAvatarUrlByContact(props.contact);
    });
    const containerAttrs = computed(() => {
      var _a, _b;
      return ((_b = (_a = preset.value.slots) == null ? void 0 : _a.container) == null ? void 0 : _b.attrs) || {};
    });
    const iconAttrs = computed(() => {
      var _a, _b;
      const AVATAR_ICON_SCALE = 0.85;
      return {
        ...((_b = (_a = preset.value.slots) == null ? void 0 : _a.icon) == null ? void 0 : _b.attrs) || {},
        ...props.icon && { icon: props.icon },
        size: props.size * AVATAR_ICON_SCALE
      };
    });
    const colorCss = computed(() => resolveColor(attrs.value.color || props.color));
    const borderWidthCss = computed(() => {
      return `${props.borderWidth}px`;
    });
    return (_ctx, _cache) => {
      const _component_b_icon = resolveComponent("b-icon");
      return openBlock(), createBlock(VHover, null, {
        default: withCtx(({ isHovering, props: hoverProps }) => [
          createElementVNode("div", mergeProps({ class: "d-inline-block" }, containerAttrs.value), [
            createVNode(VAvatar, mergeProps({
              class: [
                "b-avatar",
                {
                  ["c-pointer"]: hasOnClickListener.value,
                  ["hover"]: hasOnClickListener.value && isHovering
                },
                props.preset
              ],
              size: __props.size,
              color: colorCss.value
            }, {
              ...unref(attrs),
              ...hasOnClickListener.value && hoverProps
            }), {
              default: withCtx(() => [
                avatarSrc.value && !hasError.value ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  class: "b-avatar__image",
                  src: avatarSrc.value,
                  "aspect-ratio": 1,
                  onError: _cache[0] || (_cache[0] = ($event) => hasError.value = true)
                }, null, 40, _hoisted_1)) : (openBlock(), createBlock(_component_b_icon, normalizeProps(mergeProps({ key: 1 }, iconAttrs.value)), null, 16))
              ]),
              _: 2
            }, 1040, ["class", "size", "color"])
          ], 16)
        ]),
        _: 1
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
